var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadIcon7({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.82051 3.53846C6.11246 3.53846 5.53846 4.11246 5.53846 4.82051V19.1795C5.53846 19.8875 6.11246 20.4615 6.82051 20.4615H17.0769C17.785 20.4615 18.359 19.8875 18.359 19.1795V9.34791C18.359 9.27991 18.332 9.21469 18.2839 9.1666L12.7308 3.61356C12.6827 3.56548 12.6175 3.53846 12.5495 3.53846H6.82051ZM4 4.82051C4 3.26279 5.26279 2 6.82051 2H12.5495C13.0256 2 13.4821 2.1891 13.8187 2.52571L19.3717 8.07875C19.7083 8.41535 19.8974 8.87188 19.8974 9.34791V19.1795C19.8974 20.7372 18.6347 22 17.0769 22H6.82051C5.26279 22 4 20.7372 4 19.1795V4.82051ZM11.9487 9.17949C12.3736 9.17949 12.7179 9.52388 12.7179 9.94872V14.2455L14.4817 12.4817C14.7821 12.1813 15.2692 12.1813 15.5696 12.4817C15.87 12.7821 15.87 13.2692 15.5696 13.5696L12.4926 16.6465C12.1922 16.9469 11.7052 16.9469 11.4048 16.6465L8.32787 13.5696C8.02746 13.2692 8.02746 12.7821 8.32787 12.4817C8.62827 12.1813 9.11532 12.1813 9.41572 12.4817L11.1795 14.2455V9.94872C11.1795 9.52388 11.5239 9.17949 11.9487 9.17949Z",
    fill: "#23242A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon7);
export default __webpack_public_path__ + "static/media/download-icon-7.86d33a72cc4f0ebc0bba425b7e23e90d.svg";
export { ForwardRef as ReactComponent };